<script setup>
import { toRefs } from "vue";
import InfoHolder from "@/components/global/drawer/InfoHolder.vue";

const props = defineProps({
  company: {
    type: Object,
  },
});

const { company } = toRefs(props);
</script>

<template>
  <div v-if="Object.keys(company).length > 0" class="pa-5">
    <h1>{{ company.name }}</h1>
    <v-divider />
    <div class="d-flex box-holder">
      <div class="d-flex box-row flex-1-0-0">
        <div class="box-container mt-5">
          <h3 class="pa-2"><v-icon>mdi-domain</v-icon> Company Data</h3>
          <InfoHolder title="Name" :info="company.name" />
          <InfoHolder title="Email" :info="company.email" />
          <InfoHolder title="Telephone" :info="company.telephone" />
          <InfoHolder title="Website" :info="company.website" />
          <InfoHolder title="Location" :info="company.location" />
          <InfoHolder title="Contact Name" :info="company.contactName" />
          <InfoHolder title="Contact Email" :info="company.contactEmail" />
          <InfoHolder
            title="Contact Telephone"
            :info="company.contactTelephone"
          />
          <InfoHolder title="Workforce" :info="company.workforce?.name" />
          <InfoHolder
            title="Talent Pipeline"
            :info="company.talentPipeline?.name"
          />
          <InfoHolder title="Branch" :info="company.branch?.name" />
          <InfoHolder title="Notes" type="richText" :info="company.notes" />
        </div>
      </div>
      <div class="d-flex box-row flex-1-0-0" style="gap: 10px">
        <div class="box-container box-w3 mt-5">
          <h3 class="pa-2"><v-icon>mdi-briefcase</v-icon> Job Positions</h3>

          <div v-for="job in company.jobPositions" :key="job.id" class="pa-2">
            <v-chip>
              {{ job.name }}
            </v-chip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 48px;
  color: rgb(var(--v-theme-company));
}
.box-holder {
  gap: 20px;
  .box-row {
    flex-direction: column;
    .box-w3 {
      width: 100%;
    }
    .box-container {
      border: 1px solid rgb(var(--v-theme-company));
      h3 {
        background-color: rgb(var(--v-theme-company));
        color: white;
      }
      .info {
        .label {
          text-decoration: underline;
        }
        .answer {
          display: block;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
